import { ACTION_NAME } from './scroll-random-reducer';
export const setScrollRandom = (mathRandom) => {
    return {
        type: ACTION_NAME.SET_SCROLL_RANDOM,
        mathRandom,
    };
};
